<div *ngIf="!isEmbedded" class="security-warning">
  <div class="warning-content">
    <h2>⚠️ Security Warning</h2>
    <p>This chat must be accessed via the main system interface.</p>
    <p>Direct access is not allowed for security reasons.</p>
  </div>
</div>

<div class="chat-box-container" *ngIf="isEmbedded">
  <div class="chat-area">
    <div class="chat-header">
      <div class="header-content">
        <img src="assets/icons/Vector.svg" class="header-icon" width="47" height="38" alt="icon" />
        <div class="header-text">
          <div class="header-title">צ'אט בוט</div>
          <div class="status-row">
            <span class="status-text">מחובר</span>
            <span class="status-dot"></span>
          </div>
        </div>
      </div>
      
      
      
    </div>
    <div class="messages" #messagesContainer>
      <div *ngIf="error" class="error-message">
        {{ error }}
      </div>
      <ng-container *ngFor="let message of messages">
        <div class="message-wrapper">
          <!-- הודעת משתמש -->
          <div *ngIf="message.role === 'user'" class="message user-message">
            <div class="user-bubble-wrapper">
              <div class="user-balloon">
                <span class="user-text balloon-text" [ngClass]="'direction-' + getTextDirection(message.content)" [attr.dir]="getTextDirection(message.content)">{{ message.content }}</span>
              </div>
              <div class="msg-time">{{ message.timestamp | date:'HH:mm' }}</div>
            </div>
          </div>
      
          <!-- הודעת בוט -->
          <div *ngIf="message.role === 'bot'" class="message bot-message">
            <div class="bot-message-row">
                <div class="bot-icon">
                  <img src="assets/icons/Vector.svg" alt="bot" />
                </div>
                <div class="bot-bubble-wrapper">
                  <div class="bot-balloon" [class]="isBilingualWelcomeMessage(message.content) ? 'bilingual-message' : 'direction-' + getTextDirection(message.content)">
                    <ng-container *ngIf="isTableContent(message.content); else checkBilingual">
                      <ng-container *ngTemplateOutlet="tableTemplate; context: { $implicit: message.content, direction: getTextDirection(message.content) }"></ng-container>
                    </ng-container>
                    <ng-template #checkBilingual>
                      <ng-container *ngIf="isBilingualWelcomeMessage(message.content); else botText">
                        <ng-container *ngTemplateOutlet="bilingualTemplate; context: { $implicit: getSafeBilingualContent(message.content) }"></ng-container>
                      </ng-container>
                      <ng-template #botText>
                        <span class="bot-text balloon-text" [ngClass]="'direction-' + getTextDirection(message.content)" [attr.dir]="getTextDirection(message.content)">{{ message.content }}</span>
                      </ng-template>
                    </ng-template>
                  </div>
                  <div class="msg-time">{{ message.timestamp | date:'HH:mm' }}</div>
                  
                  <!-- Like/Dislike Buttons -->
                  <div *ngIf="message.question" class="review-buttons">
                    <button 
                      class="review-btn like-btn" 
                      [class.active]="message.reviewStatus === 'liked'"
                      [class.dimmed]="message.reviewStatus === 'disliked'"
                      [disabled]="message.reviewStatus !== null"
                      (click)="submitReview(message, true)"
                      title="Helpful">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H16.4262C17.907 22 19.1662 20.9197 19.3914 19.4562L20.4683 12.4562C20.7479 10.6389 19.3418 9 17.5032 9H14C13.4477 9 13 8.55228 13 8V4.46584C13 3.10399 11.896 2 10.5342 2C10.2093 2 9.91498 2.1913 9.78306 2.48812L7.26394 8.40614C7.09746 8.76727 6.74857 9 6.35013 9H4C2.89543 9 2 9.89543 2 11V13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                    <button 
                      class="review-btn dislike-btn" 
                      [class.active]="message.reviewStatus === 'disliked'"
                      [class.dimmed]="message.reviewStatus === 'liked'"
                      [disabled]="message.reviewStatus !== null"
                      (click)="submitReview(message, false)"
                      title="Not helpful">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 2V13M22 11V4C22 2.89543 21.1046 2 20 2H7.57377C6.09297 2 4.83379 3.08028 4.60863 4.54377L3.53168 11.5438C3.25208 13.3611 4.65822 15 6.49678 15H10C10.5523 15 11 15.4477 11 16V19.5342C11 20.896 12.104 22 13.4658 22C13.7907 22 14.085 21.8087 14.2169 21.5119L16.7361 15.5939C16.9025 15.2327 17.2514 15 17.6499 15H20C21.1046 15 22 14.1046 22 13V11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              
          </div>
        </div>
      </ng-container>
      
      <div *ngIf="loading" class="message bot-message">
        <div class="message-content loading">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>
    <div class="chat-input new-input-row">
      <span class="send-icon" (click)="sendMessage()" [class.disabled]="loading || !question.trim() || !conversationId">
        <img src="assets/icons/send-message.svg" width="20" height="18" alt="send" />
      </span>
      <input 
        type="text" 
        [(ngModel)]="question" 
        placeholder="הקלד הודעה"
        (keyup.enter)="sendMessage()"
        [disabled]="loading || !conversationId"
        class="borderless-input"
        [attr.dir]="determineInputDir(question)"
        [ngClass]="getInputDirectionClass()"
      >
      <div class="emoji-wrapper" style="position: relative;">
        <span class="emoji-icon" (click)="toggleEmojiPicker($event)">
          <img src="assets/icons/emoji.svg" width="24" height="24" alt="emoji" />
        </span>
        <div class="emoji-picker-container" *ngIf="showEmojiPicker" (click)="$event.stopPropagation()">
          <emoji-mart
            [set]="'apple'"
            [showPreview]="false"
            [style]="{ width: '320px', height: '350px' }"
            (emojiSelect)="addEmoji($event); showEmojiPicker = false;">
          </emoji-mart>
        </div>
        
      </div>
      
    </div>
  
  </div>
</div>

<ng-template #textTemplate let-content>
  <span class="bot-text balloon-text">{{ content }}</span>
</ng-template>

<ng-template #tableTemplate let-content let-direction="direction">
  <div class="table-container" [ngClass]="['direction-' + direction, (content?.rows?.length || 0) > 5 ? 'has-many-rows' : '']">
    <div class="table-header">
      <button class="download-btn" (click)="downloadTableAsExcel(content)" title="Download as Excel">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 192 192" fill="none">
          <path d="M56 30c0-1.662 1.338-3 3-3h108c1.662 0 3 1.338 3 3v132c0 1.662-1.338 3-3 3H59c-1.662 0-3-1.338-3-3v-32m0-68V30" style="fill-opacity:.402658;stroke:#fff;stroke-width:12;stroke-linecap:round;paint-order:stroke fill markers"/>
          <rect width="68" height="68" x="-58.1" y="40.3" rx="3" style="fill:none;fill-opacity:.402658;stroke:#fff;stroke-width:12;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke fill markers" transform="translate(80.1 21.7)"/>
          <path d="M138.79 164.725V27.175M56.175 58.792H170M170 96H90.328M169 133.21H56.175M44.5 82l23 28m0-28-23 28" style="fill:none;stroke:#fff;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"/>
        </svg>
      </button>
    </div>
    <table class="data-table">
      <thead>
        <tr>
          <th *ngFor="let column of content.columns">{{ column }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of content.rows">
          <tr>
            <ng-container *ngFor="let col of content.originalColumns">
              <td>{{ row[col] }}</td>
            </ng-container>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #bilingualTemplate let-content>
  <div class="bilingual-message-container">
    <div class="hebrew-section direction-rtl" dir="rtl">
      <span class="bot-text balloon-text">{{ content.hebrew }}</span>
    </div>
    <div class="separator"></div>
    <div class="english-section direction-ltr" dir="ltr">
      <span class="bot-text balloon-text">{{ content.english }}</span>
    </div>
  </div>
</ng-template>

